export default {
  columns: {
    strategy: 'Estrategia',
    source: 'Fuente',
    async: 'Async',
    content: 'Contenido',
    edit: 'Editar',
    delete: 'Eliminar',
  },
  buttons: {
    add_script: 'Añadir script',
  },
};
